/*
 * H2S search suggestions - adds "recent searches" term chips to the predictive
 * search empty state and records searches as the shopper performs them.
 * Self-contained: no imports, no dependency on the predictive-search web component,
 * so it cannot break the theme's existing search behaviour.
 */
(function () {
  if (window.__h2sSearchSuggestInit) return;
  window.__h2sSearchSuggestInit = true;

  var KEY = 'h2s:recent-searches';
  var MAX = 6;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (t) { return typeof t === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  }

  function record(term) {
    term = (term || '').replace(/\s+/g, ' ').trim();
    if (!term || term.length > 80) return;
    // Skip internal lookups (e.g. recently-viewed "id:" queries / wildcards)
    if (/(^|\s)id:/.test(term) || term.indexOf('*') !== -1) return;
    var lower = term.toLowerCase();
    var list = read().filter(function (t) { return t.toLowerCase() !== lower; });
    list.unshift(term);
    write(list);
  }

  function searchBase() {
    var r = window.Theme && Theme.routes && Theme.routes.search_url;
    return r || '/search';
  }

  function searchUrl(term) {
    return searchBase() + '?q=' + encodeURIComponent(term);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Capture the query whenever the shopper lands on the search results page.
  function recordFromUrl() {
    try {
      var path = location.pathname.replace(/\/+$/, '');
      var base = searchBase().replace(/\/+$/, '');
      if (path === base || /\/search$/.test(path)) {
        var q = new URLSearchParams(location.search).get('q');
        if (q) record(q);
      }
    } catch (e) {}
  }

  // Render recent chips into every recent container currently in the DOM.
  function renderRecent(root) {
    var groups = (root || document).querySelectorAll('[data-h2s-recent]');
    if (!groups.length) return;
    var list = read();
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var listEl = group.querySelector('[data-h2s-recent-list]');
      if (!listEl) continue;
      if (!list.length) {
        group.hidden = true;
        listEl.innerHTML = '';
        continue;
      }
      group.hidden = false;
      listEl.innerHTML = list
        .map(function (t) {
          return (
            '<a class="pills__pill predictive-search-results__pill h2s-suggest-chip" href="' +
            escapeHtml(searchUrl(t)) +
            '">' +
            escapeHtml(t) +
            '</a>'
          );
        })
        .join('');
    }
  }

  function clearRecent() {
    write([]);
    renderRecent();
  }

  // Clear button (delegated so it survives re-renders).
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-h2s-recent-clear]')) {
      e.preventDefault();
      e.stopPropagation();
      clearRecent();
    }
  });

  // Record a chip click too, then let navigation proceed normally.
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var chip = target.closest('.h2s-suggest-chip');
      if (!chip) return;
      try {
        var q = new URL(chip.href, location.origin).searchParams.get('q');
        if (q) record(q);
      } catch (err) {}
    },
    true
  );

  // Re-populate recents whenever a search input gains focus (covers the
  // empty-state being morphed back in after a reset).
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('search-input')) {
      renderRecent();
    }
  });

  // Collapse the inline (non-modal) predictive search when the shopper clicks
  // or presses Escape outside of it. The modal version manages its own open
  // state, so it is left untouched.
  function collapseInline(keepInside) {
    var comps = document.querySelectorAll('predictive-search-component.predictive-search--expanded');
    for (var i = 0; i < comps.length; i++) {
      var comp = comps[i];
      if (comp.closest('dialog')) continue; // leave the modal alone
      if (keepInside && comp.contains(keepInside)) continue;
      comp.classList.remove('predictive-search--expanded');
    }
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      var t = e.target;
      if (t && t.closest) {
        var comp = t.closest('predictive-search-component');
        if (comp && !comp.closest('dialog')) return; // click was inside the inline search
      }
      collapseInline();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') collapseInline();
  });

  function init() {
    recordFromUrl();
    renderRecent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
